// extracted by mini-css-extract-plugin
export default {"form":"Status_form__f5cBw","wrap":"Status_wrap__qdhxn","button":"Status_button__h4QF5"};